import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the dtaIllustrationPage state domain
 */

const selectDtaIllustrationPageDomain = state =>
  state.get('dtaIllustrationPage', initialState);

/**
 * Other specific selectors
 */
const makeSelectLifeAssured = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('dtaConfig').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectIsCalculateQuotePage = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('isCalculateQuotePage'),
  );

const makeSelectCompletedDialog = () =>
  createSelector(selectDtaIllustrationPageDomain, substate =>
    substate.get('completedDialog'),
  );

/**
 * Default selector used by DtaIllustrationPage
 */
export {
  selectDtaIllustrationPageDomain,
  makeSelectLifeAssured,
  makeSelectInitialLifeAssured,
  makeSelectProductConfig,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectIsCalculateQuotePage,
  makeSelectCompletedDialog,
};
